export default function StickerPlaceholderIcon({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none"
      aria-hidden="true" focusable="false" style={{ display: "block", flexShrink: 0 }}>
      <path d="M7 3.5h18A3.5 3.5 0 0 1 28.5 7v12L19 28.5H7A3.5 3.5 0 0 1 3.5 25V7A3.5 3.5 0 0 1 7 3.5Z"
        fill="currentColor" fillOpacity=".14" stroke="currentColor" strokeWidth="1.8" />
      <path d="M19 28v-5.5A3.5 3.5 0 0 1 22.5 19H28" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="m14 9 1.5 3.5L19 14l-3.5 1.5L14 19l-1.5-3.5L9 14l3.5-1.5L14 9Z"
        fill="currentColor" />
    </svg>
  );
}